import Rest from '@services/Rest';

/**
 * @typedef {ReconcileSalesService}
 */
export default class ReconcileSalesService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/reconcile/pagarme/transaction/'
}